module.exports = " <li class=side-menu-list__item> <a href=# class=side-menu-list__icon :class=icon v-on:click.prevent=toggle></a> <div class=sidebar v-if=active> <div class=sidebar__block> <p class=sidebar__title>Ricoh Portal Applications:</p> <ul class=portal-list> <li v-for=\"portal in portals\"> <a :href=portal.Url target=_blank>{{portal.Name}}</a> </li> </ul> </div> </div> <div v-if=active class=side-menu-closer v-on:click.prevent=toggle> </div> </li> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/app/navigation/sidebar/SidebarPortal.vue
// module id = 169
// module chunks = 0